import { useParams } from "react-router"
import $api from "."

export default function fetchBlog({params}){
   return $api.get(`post/${params.blogId}`)

}